import React, { useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import ProcessDevice from './ProcessDevice';
import OurProductsSection from "./OurProductsSection"
import battery1 from "../assets/battery1.png"
import battery2 from "../assets/battery2.png"
import battery3 from "../assets/battery3.png"
import battery4 from "../assets/battery4.png"
import battery5 from "../assets/battery5.png"
import battery6 from "../assets/battery6.jpg"

import '../styles/EnergyIndustry.css';

import EnergyIndustryImg from '../assets/EnergyIndustryImg.png'

const EnergyIndustry = () => {

  return (
    <div className="EnergyIndustry">
      <Header />

      {/* Hero Banner Section */}
      {/* <section className="hero-banner7">
        <div className="hero-content">
          <h1>AUTOMOBILES AND PARTS</h1>
          <div className="breadcrumb">
            <span><a href="/" style={{ color: "#ACECFC" }}>Home</a></span> ⪢ <span>Automobiles And Parts</span>
          </div>
        </div>
      </section> */}

<section className="EnergyIndustry-hero-clean">
  <div className="hero-text">
    <h1>Energy Industry</h1>
    <p>
From electrode manufacturing and battery cell assembly to cell finishing to module and pack assembly, we provide sensors that address your specific needs in cycle time, traceability, and quality control.</p>
  </div>
  <br/>
  <div className="hero-image">
    <img src={EnergyIndustryImg} alt="Energy Industry" />
  </div>
</section>


<ProcessDevice />

 <section className="battery-features">
      <div className="feature-row">
        <div className="feature-image"><img src={battery1} alt="Entrance protection" /></div>
        <div className="feature-text">
          <h3>Entrance protection of the winding unit</h3>
          <p>The continuous winding action of the material during the electrode production process may cause danger. The SAF series of safety light curtains can reliably monitor the entrance of the winding unit.</p>
        </div>
      </div>

      <div className="feature-row reverse">
        <div className="feature-image"><img src={battery2} alt="Use photoelectric sensor" /></div>
        <div className="feature-text">
          <h3>Use photoelectric sensor to detect battery</h3>
          <p>The PTN series sensor detects dark or highly reflective battery cells, modules, or shells without a reflector.</p>
        </div>
      </div>

      <div className="feature-row">
        <div className="feature-image"><img src={battery3} alt="Splicing tape detection" /></div>
        <div className="feature-text">
          <h3>Splicing tape detection</h3>
          <p>During roll change, the color mark sensor detects tape connections to remove them before film processing.</p>
        </div>
      </div>

      <div className="feature-row reverse">
        <div className="feature-image"><img src={battery4} alt="Film tension measurement" /></div>
        <div className="feature-text">
          <h3>Film tension measurement</h3>
          <p>Stress must be maintained using the MR-C8 web cylinder to control reversing rollers and film tension.</p>
        </div>
      </div>

      <div className="feature-row">
        <div className="feature-image"><img src={battery5} alt="Battery cell identification" /></div>
        <div className="feature-text">
          <h3>Battery cell identification</h3>
          <p>The PGS + PD-R62 fiber optic sensor combo triggers barcode scanning of 1D barcodes.</p>
        </div>
      </div>

      <div className="feature-row reverse">
        <div className="feature-image"><img src={battery6} alt="Detect warping" /></div>
        <div className="feature-text">
          <h3>Detect the warping degree of the substrate</h3>
          <p>The laser displacement sensor can accurately detect substrate warping.</p>
        </div>
      </div>
    </section>


<OurProductsSection />

      <Footer />
    </div>
  );
};
export default EnergyIndustry;